import Vue from 'vue'

// import { Button, Form, FormItem, Icon, Input } from 'element-ui'
import element from 'element-ui'
// import { Message } from 'element-ui'
Vue.use(element)
// Vue.use(Form)
// Vue.use(Input)
// Vue.use(FormItem)
// Vue.use(Icon)
// Vue.prototype.$message = Message
